<script setup>
import { onMounted, defineProps, defineEmits, ref, nextTick, watch, defineExpose, onBeforeMount, inject} from 'vue';
import ProductsBlock from "@/components/ProductsBlock";
import AudioPlayer from 'vue3-audio-player';
import 'vue3-audio-player/dist/style.css'
import axios from 'axios';
import { useWindowSize } from '@vueuse/core';
const { width } = useWindowSize();

const props = defineProps({
  pageType: {
    type: String,
    default: '',
  },
  data: {
    type: Object,
    default: () => {}
  },
  isSharing: {
    type: Boolean,
    default: false
  },
  sharedId: {
    type: String,
    default: undefined
  }
})

const emit = defineEmits(['goBack']);
const loading = ref(false);
const showResult = ref(false);
const selectedOptions = ref([]);
const showAlert = ref(false);
const showIntro = ref(true);
const showFilters = ref(false);
const showSharing = ref(false);
const filters = ref(undefined);
const resultId = ref(null);
const resultExist = ref(false);
const baseUrl = window.drupalSettings.path.baseUrl;

const hasUndefined = arr => arr.includes(undefined);

const requestData = () => {
  return {"action":"get_result","game": props.pageType,"values": selectedOptions.value}
};

const getFilters = async () => {
  try {
    const response = await axios.post(
        `${baseUrl}api/lessons`,
        {"action":"get_data","game": props.pageType},
        { headers: { "Content-Type": "application/json" } }
    )
    if (response.status === 200) {
      filters.value = response.data.questions;
    } else {
      console.log('Ошибка', response);
    }

  } catch (err) {
    console.error("Ошибка загрузки фильтров:", err);
  }
}

const getResult = async () => {
  if (selectedOptions.value.length < 3 || hasUndefined(selectedOptions.value)) {
    showAlert.value = true;
    return;
  }
  sendEvent(
      'create_button_click',
      'stage',
      props.pageType,
      filters.value[0].answers.find((item) => item.id === selectedOptions.value[0]).text,
      filters.value[1].answers.find((item) => item.id === selectedOptions.value[1]).text,
      filters.value[2].answers.find((item) => item.id === selectedOptions.value[2]).text
  );
  try {
    loading.value = true;
    const response = await axios.post(
        `${baseUrl}api/lessons`,
        requestData(),
        { headers: { "Content-Type": "application/json" } }
    );
    if (response.status === 200) {
      resultId.value = response.data.id;
      resultExist.value = true;
      showResult.value = true;
      check();
      scrollToBlock('result');
    } else {
      console.log('Ошибка', response);
    }

  } catch (err) {
    console.error("Ошибка загрузки результата:", err);
  } finally {
    loading.value = false;
  }
};

const checkResult = async () => {
  loading.value = true;
  try {
    const response = await axios.head(`${baseUrl}${props.pageType}/result/${resultId.value}/media/view`);
    if (response.status === 200) {
      resultExist.value = true;
    }
  } catch (err) {
    resultExist.value = false;
  } finally {
    loading.value = false;
  }
};

const scrollToBlock = (id) => {
  nextTick(() => {
    document.getElementById(id)?.scrollIntoView({behavior: "smooth"});
  })
};

const clearUrl = () => {
  window.history.replaceState({}, document.title, window.location.pathname);
}

const goBack = () => {
  const step = showResult.value ? 2 : 1;
  sendEventAlt(`backtolessons_button${step}_click`, {name: 'stage', value: props.pageType});
  emit('goBack');
  selectedOptions.value = [];
  showResult.value = false;
  showIntro.value = true;
  showFilters.value = false;
  showSharing.value = false;
  resultExist.value = false;
  getFilters();
  clearUrl();
}

const tryAgain = () => {
  sendEventAlt('tryagain_button_click', { name: 'stage', value: props.pageType })
  selectedOptions.value = [];
  showResult.value = false;
  showFilters.value = true;
  showIntro.value = false;
  showSharing.value = false;
  resultExist.value = false;
  check();
  scrollToBlock('create');
}

watch(width, (val) => {
  const app = document.getElementById('app')
  app.classList.toggle('_mobile', val < 730)
}, { immediate: true })

const check = (step = 2) => {
  const app = document.getElementById('app')
  app.classList.toggle('_create', !showResult.value && step === 2)
}

defineExpose({ check });

const sharingUrl = (platform) => {
  const cleanUrl = window.location.origin + window.location.pathname;
  const urlString = `${cleanUrl}?shared_id=${resultId.value}`;
  const encodedUrl = encodeURIComponent(urlString);
  const imageUrl = encodeURIComponent(`${window.location.origin}/modules/custom/hrutka/img/logo.png`);

  const platforms = {
    telegram: `https://t.me/share/url?url=${encodedUrl}&text=${props.data.sharingText}`,
    vk: `https://vk.com/share.php?url=${encodedUrl}&title=${props.data.sharingText}&image=${imageUrl}`,
    whatsapp: `https://api.whatsapp.com/send?text=${props.data.sharingText} ${encodedUrl}`
  };

  return platforms[platform] || '';
};

onBeforeMount(() => {
  if (props.isSharing) {
    resultId.value = props.sharedId;
    showResult.value = true;
    checkResult();
  } else {
    getFilters();
  }
})

const sendEvent = inject('sendEvent');
const sendEventAlt = inject('sendEventAlt');

onMounted(() => {
})

</script>

<template>
  <div class="create">
    <template v-if="!showResult">
      <template v-if="showIntro || width > 730">
        <img :src="require(`@/assets/img/${pageType}/girl-${pageType}.png`)" alt="" class="create__girl"/>
        <img :src="require(`@/assets/img/${pageType}/boy-${pageType}.png`)" alt="" class="create__boy"/>
        <div class="create__title" v-html="data.createTitle" id="create"></div>
        <div class="create__text" v-html="data.createText"></div>
      </template>
      <div class="filters" v-if="showFilters || width > 730">
        <div class="filters__lvl1" v-for="(item, index) in filters" :key="`item${index}`">
          <h3>{{ item.text }}</h3>
          <div class="filters__lvl1-options">
            <div
                :class="['filters__lvl2', {'_selected': subitem.id === selectedOptions?.[index]}]"
                v-for="(subitem, subindex) in item.answers"
                :key="`subitem${subindex}`"
                @click="selectedOptions[index] = subitem.id"
            >
              <div class="filters__lvl2-image">
                <img :src="subitem.image" alt="">
              </div>
              <span>{{ subitem.text }}</span>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div
        class="create__title create__title_result"
        v-html="isSharing ? data.sharingPageTitle : data.resultTitle"
        id="result"
      ></div>
      <template v-if="resultExist">
        <template v-if="pageType === 'music'">
          <div class="create__result create__result_player">
            <img :src="require(`@/assets/img/${pageType}/girl-${pageType}.png`)" alt=""/>
            <div class="player">
              <AudioPlayer
                  :option="{
                    src: `${baseUrl}${pageType}/result/${resultId}/media/view`,
                    coverImage: false,
                    coverRotate: false,
                    progressBarColor: '#800080',
                    indicatorColor: '#800080'
                   }"
                  @loadedmetadata="scrollToBlock('result')"
                  @play="sendEventAlt('music_video_play', {name: 'stage', value: pageType});"
              ></AudioPlayer>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="create__result">
            <img :src="`${baseUrl}${pageType}/result/${resultId}/media/view`" alt=""/>
          </div>
        </template>
      </template>
      <div v-else-if="!loading" class="create__text">
        Не удалось получить результат :(
      </div>
      <div class="create__result-actions" v-if="resultExist">
        <a
            href=""
            class="create__button create__button_bordered"
            @click.prevent="showSharing = true; sendEventAlt('share_button_click', {name: 'stage', value: pageType});"
            v-if="!isSharing"
        >Поделиться</a>
        <a
            :href="`${baseUrl}${pageType}/result/${resultId}/media/download`"
            class="create__button"
            @click="sendEventAlt('download_button_click', { name: 'stage', value: pageType })"
        >Скачать</a>
        <div class="sharing" v-show="showSharing">
          <h3 class="sharing__title">Поделиться</h3>
          <div class="sharing__media">
            <a
                :href="sharingUrl('telegram')"
                class="_telegram"
                target="_blank"
                @click="showSharing = false; sendEventAlt('share_msngr_icon_click', { name: 'stage', value: pageType }, { name: 'msngr', value: 'Telegram' });"
            >
              <img :src="require('@/assets/img/telegram.png')" alt="Telegram">
            </a>
            <a
                :href="sharingUrl('whatsapp')"
                class="_whatsApp"
                target="_blank"
                @click="showSharing = false; sendEventAlt('share_msngr_icon_click', { name: 'stage', value: pageType }, { name: 'msngr', value: 'WhatsApp' });"
            >
              <img :src="require('@/assets/img/whatsapp.png')" alt="WhatsApp">
            </a>
          </div>
          <a href="" class="create__button create__button_bordered" @click.prevent="showSharing = false">Закрыть</a>
        </div>
      </div>
      <div
          :class="['create__text', 'create__text_result', {'create__text_sharing': isSharing}]"
          v-html="isSharing ? data.sharingPageText : data.resultText"
      ></div>
    </template>
    <div class="create__nav">
      <a
        href=""
        :class="isSharing ? 'create__button create__button_bordered' : 'create__return'"
        @click.prevent="goBack()"
      >
        <svg v-if="!isSharing" width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16 0.499999C24.8366 0.5 32 7.66344 32 16.5C32 25.3366 24.8366 32.5 16 32.5C7.16344 32.5 -1.08564e-06 25.3366 -6.99382e-07 16.5C-3.13124e-07 7.66344 7.16344 0.499999 16 0.499999Z" fill="white"/>
          <path d="M13.7002 14.1016L11.4669 16.3349L13.7002 18.5682" stroke="#800080" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M11.4666 16.3359L20.3999 16.3359" stroke="#800080" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        {{ isSharing ? 'Смотреть уроки' : width > 730 ? 'Назад к урокам' : 'К урокам' }}
      </a>
      <template v-if="!showResult">
        <template v-if="width > 730">
          <button class="create__button" @click.prevent="getResult();" :disabled="loading">{{ loading ? 'Загрузка...' : 'Создать' }}</button>
        </template>
        <template v-else>
          <a href="" class="create__button" @click.prevent="showIntro = false; showFilters = true;" v-if="showIntro">Далее</a>
          <button class="create__button" @click.prevent="getResult();" v-else-if="showFilters" :disabled="loading">{{ loading ? 'Загрузка...' : 'Создать' }}</button>
        </template>
      </template>
      <a
        href=""
        class="create__return"
        @click.prevent="tryAgain();"
        v-else-if="!isSharing"
      >
        <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16.5 -6.99382e-07C25.3366 -3.13124e-07 32.5 7.16344 32.5 16C32.5 24.8366 25.3366 32 16.5 32C7.66344 32 0.499999 24.8366 0.499999 16C0.5 7.16344 7.66344 -1.08564e-06 16.5 -6.99382e-07Z" fill="white"/>
          <path d="M8.5 15L11.5 18L14.5 15" stroke="#800080" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M17 21C20.0376 21 22.5 18.5376 22.5 15.5C22.5 12.4624 20.0376 10 17 10C13.9624 10 11.5 12.4624 11.5 15.5" stroke="#800080" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        Попробовать ещё раз
      </a>
    </div>
    <div class="products">
      <ProductsBlock v-if="showResult"/>
    </div>
    <div class="create__alert" v-if="showAlert">
      <div class="create__alert-box">
        <p>Нужно выбрать один из вариантов в&nbsp;каждом вопросе</p>
        <a href="" class="create__button create__button_bordered" @click.prevent="showAlert = false;">Понятно</a>
      </div>
    </div>
  </div>
</template>